import { NgModule } from '@angular/core';
import { LayoutModule } from '../ui-components/layout/layout.module';
import { PageNotFoundComponent } from './page-not-found.component';

@NgModule({
  imports: [
    LayoutModule
  ],
  declarations: [
    PageNotFoundComponent,
  ],
  exports: [
    PageNotFoundComponent,
  ]
})
export class PageNotFoundModule { }
